// extracted by mini-css-extract-plugin
export default {"intro":"intro_RRtlKt","platformWrapper":"platformWrapper_d+htxC","platform":"platform_IdLPPX"};